export default {
  token: null,
  user: {
    name: "",
    surname: "",
    avatar: ""
  }
};
